import { ListItem, ListItemText, Typography } from '@mui/material';

// Ein Eintrag in der Benachrichtigungs-Liste.
function BenachrichtigungItem({ b, onClick }) {
    return (
        <ListItem
            onClick={() => onClick(b)}
            sx={{
                bgcolor: b.gelesen ? 'transparent' : 'action.hover',
                '&:hover': {
                    bgcolor: 'action.selected',
                },
            }}
        >
            <ListItemText
                primary={
                    <Typography
                        variant="body2"
                        fontWeight={b.gelesen ? 400 : 600}
                    >
                        {b.titel}
                    </Typography>
                }
                secondary={[
                    <Typography
                        key="nachricht"
                        component="span"
                        variant="body2"
                        color="text.secondary"
                        display="block"
                    >
                        {b.nachricht}
                    </Typography>,
                    <Typography
                        key="datum"
                        component="span"
                        variant="caption"
                        color="text.secondary"
                        display="block"
                    >
                        {new Date(b.erstellt_am).toLocaleDateString('de-DE', {
                            day: '2-digit',
                            month: 'short',
                            hour: '2-digit',
                            minute: '2-digit',
                        })}
                    </Typography>,
                ]}
            />
        </ListItem>
    );
}

export default BenachrichtigungItem;
